export const errorLogin = (error) => {
    const defaultMessage = "Something went wrong. Please try again.";
    const code = error && (error.code || error.errorCode);

    switch (code) {
        case "auth/user-not-found":
            return "Email not found. Please sign up to create an account.";
        case "auth/wrong-password":
            return "Incorrect password. Please try again.";
        case "auth/invalid-email":
            return "Please enter a valid email address.";
        case "auth/user-disabled":
            return "This account has been disabled. Please contact support.";
        case "auth/missing-password":
            return "Password not set for this account. Please click 'Forgot Password' to generate your password.";
        case "auth/missing-email":
            return "Please enter your email address.";
        case "auth/email-already-in-use":
            return "This email is already registered. Please log in instead.";
        case "auth/account-exists-with-different-credential":
            return "An account already exists with this email using a different sign-in method.";
        case "auth/invalid-verification-code":
            return "Invalid code. Please enter the correct code.";
        case "auth/invalid-verification-id":
            return "Verification session expired. Please request a new code.";
        case "auth/code-expired":
            return "This code has expired. Please request a new one.";
        case "auth/invalid-credential":
            return "Invalid credentials. Please enter valid details.";
        case "auth/weak-password":
            return "Password is too weak. Please use at least 6 characters.";
        case "auth/too-many-requests":
            return "Too many attempts. Please try again after some time.";
        case "auth/network-request-failed":
            return "Network error. Please check your internet connection.";
        case "auth/popup-closed-by-user":
            return "Sign-in was cancelled. Please try again.";
        case "auth/popup-blocked":
            return "Sign-in popup was blocked by the browser. Please allow popups and try again.";
        case "auth/cancelled-popup-request":
            return "Sign-in was cancelled. Please try again.";
        case "auth/operation-not-allowed":
            return "This sign-in method is not enabled. Please contact support.";
        case "auth/requires-recent-login":
            return "Please log in again to continue.";
        case "auth/invalid-phone-number":
            return "Please enter a valid phone number.";
        case "auth/missing-phone-number":
            return "Please enter your phone number.";
        case "auth/quota-exceeded":
            return "Service is temporarily unavailable. Please try again later.";
        case "auth/captcha-check-failed":
            return "Captcha verification failed. Please try again.";
        case "auth/invalid-app-credential":
            return "Verification failed. Please refresh the page and try again.";
        case "auth/app-deleted":
        case "auth/app-not-authorized":
            return "Authentication service is unavailable. Please contact support.";
        case "auth/expired-action-code":
            return "This link has expired. Please request a new one.";
        case "auth/invalid-action-code":
            return "This link is invalid or has already been used.";
        case "auth/unauthorized-domain":
            return "This domain is not authorized for sign-in.";
        case "auth/credential-already-in-use":
            return "These credentials are already linked to another account.";
        case "auth/internal-error":
            return "Something went wrong. Please try again.";
        default: {
            const raw = (error && error.message) || "";
            if (!raw) return defaultMessage;
            const match = raw.match(/\(auth\/[a-z0-9-]+\)/i);
            if (match) return defaultMessage;
            return raw;
        }
    }
};
